export default __webpack_public_path__ + "static/media/SundanceBG.c24d5220.svg";